import { useEffect, type ReactNode } from 'react';
import './legacyEmulator.css';

/**
 * The PHP show_full pages own the whole viewport. Keep the product application
 * chrome out of this route tree just as the isolated MedCall routes do.
 */
export const LegacyRouteFrame = ({ children }: { children: ReactNode }) => {
  useEffect(() => {
    document.body.classList.add('legacy-emulator-active');
    return () => document.body.classList.remove('legacy-emulator-active');
  }, []);

  return <div className="legacy-emulator">{children}</div>;
};
